import React from 'react';

import { Modal as BootstrapModal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { ModalContext } from './ModalContext';

interface IModalHeaderProps {
    closeButton: boolean;
}

export const ModalSimpleHeader = ({closeButton, children}: React.PropsWithChildren<IModalHeaderProps>) => {
    const {isSubmitting, onCancel} = React.useContext(ModalContext);

    return (
        <BootstrapModal.Header>
            <BootstrapModal.Title className="Modal__simple-header-title my-auto">{children}</BootstrapModal.Title>
            {(closeButton && !isSubmitting) && (
                <button className="close Modal__header-close-button" onClick={onCancel}>
                    <FontAwesomeIcon icon={faTimes} size="lg"/>
                </button>
            )}
        </BootstrapModal.Header>
    );
};

ModalSimpleHeader.defaultProps = {
    closeButton: true,
};
